import cx from 'classnames'
import Styles from './ImageThumbnail.module.scss'
import { VideoThumbnailProps } from './Types'
import { useHover } from '@react-aria/interactions'
import { Checkbox } from 'blaze-ui/Checkbox/Checkbox'
import { useEffect, useState } from 'react'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'

export const VideoThumbnail = ({
  video,
  onToggleSelect,
  isSelected,
  label,
  duration,
  controls = false,
}: VideoThumbnailProps) => {
  const { hoverProps, isHovered } = useHover({})
  const [error, setError] = useState(false)
  const { isMobile } = useResponsiveDesign()

  const handleSelect = () => {
    if (error) return
    onToggleSelect?.(video)
  }

  useEffect(() => {
    if (isSelected && error) {
      onToggleSelect?.(video)
    }
  }, [error, isSelected, onToggleSelect, video])

  return (
    <div
      {...hoverProps}
      className={cx(Styles.imageThumbnail, {
        [Styles.hovered]: isHovered,
        [Styles.selected]: isSelected,
        [Styles.errored]: error,
      })}
      onClick={handleSelect}
    >
      {error ? (
        <div className={Styles.error}>Error loading video</div>
      ) : (
        <>
          <video
            src={video.url}
            controls={controls}
            onError={() => {
              setError(true)
            }}
          />
          {duration && !controls && <VideoDuration duration={duration} />}
        </>
      )}
      {(isSelected || isHovered) && !error && (
        <div className={Styles.checkbox}>
          <Checkbox
            color="var(--selected-fill)"
            size={isMobile ? 20 : 28}
            isSelected={isSelected}
            aria-label="Select image"
          />
        </div>
      )}
      {label && <p className={Styles.label}>{label}</p>}
    </div>
  )
}
